import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { RunTaskForm } from './FormView';

const Component = () => (
  <>
    <Switch>
      <Route exact path='/admin/tasks' component={RunTaskForm} />
    </Switch>
  </>
);

export default Component;
